export default __webpack_public_path__ + "static/media/(Fast)Quick Charge (CHAdeMO).f09f90ac.svg";